"use client";

import { createContext, use } from "react";

export interface AIChatInputContextValue {
  state: {
    text: string;
    files: File[];
    isStreaming: boolean;
    isStopping?: boolean;
    isDisabled: boolean;
  };
  actions: {
    setText: (text: string) => void;
    addFiles?: (files: File[]) => void;
    removeFile?: (index: number) => void;
    send: () => void;
    cancel: () => void;
  };
}

export const AIChatInputContext = createContext<AIChatInputContextValue | null>(
  null,
);

export function useAIChatInputContext(): AIChatInputContextValue {
  const ctx = use(AIChatInputContext);
  if (!ctx) {
    throw new Error(
      "useAIChatInputContext must be used within an AIChat.Input",
    );
  }
  return ctx;
}
